import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginBottom: 10,
  },
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  gridVertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  innerGrid: {
    marginBottom: 10,
  },
  iconButton: {
    padding: 5,
    color: 'white',
    borderRadius: 50,
    cursor: 'pointer',
    marginRight: 5,
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  headerIconAndTitle: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& span': {
      fontSize: '0.7vw',
      fontWeight: 'bold',
    },
  },
  summaryRow: {
    display: 'flex',
    gap: 12,
    marginBottom: 6,
  },
  summaryField: {
    flex: 1,
    minWidth: 0,
  },
  summaryValue: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  rsuSectionLabel: {
    marginTop: 4,
    marginBottom: 2,
  },
  rsuList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    alignItems: 'center',
    '& li': {
      margin: 0,
      padding: 0,
      lineHeight: 1,
    },
  },
  rsuLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    margin: 0,
    fontSize: '0.7rem',
    lineHeight: 1.2,
    padding: '1px 6px',
    borderRadius: 3,
    background: 'rgba(0, 90, 187, 0.05)',
    color: '#005abb',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    verticalAlign: 'top',
    maxWidth: '100%',
    '&:hover': {
      background: 'rgba(0, 90, 187, 0.18)',
      color: '#003f82',
    },
  },
  rsuStatusIcon: {
    display: 'inline-flex',
    flexShrink: 0,
    lineHeight: 0,
    '& svg': {
      width: 14,
      height: 14,
    },
  },
  rsuLinkLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  rsuText: {
    display: 'inline-block',
    margin: 0,
    fontSize: '0.7rem',
    lineHeight: 1.2,
    padding: '1px 6px',
    color: 'inherit',
    verticalAlign: 'top',
  },
  ivimSectionTitle: {
    marginTop: 10,
    marginBottom: 8,
  },
  ivimList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
  },
  ivimLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: 'none',
    border: 'none',
    padding: '4px 0',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    font: 'inherit',
    color: 'inherit',
  },
  faultList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: 6,
    },
  },
}));

export default styles;
